



























































































import Vue from "vue";
import PROJECTS from "@/graphql/projects/Projects.gql";
import PROJECT_DELETE from "@/graphql/projects/ProjectDelete.gql";
import ProjectDialog from "@/components/projects/ProjectDialog.vue";

import {
  Projects_projects_edges_node as Project,
  Projects_projects as ProjectConnection,
  Projects_projects_edges_node
} from "@/api-types";
import * as R from "ramda";

export default Vue.extend({
  components: { ProjectDialog },
  name: "Projects",
  apollo: {
    projects: {
      query: PROJECTS
    }
  },
  data: () => ({
    removeProject: null as Project | null,
    editProject: "",
    projects: null as ProjectConnection | null,
    headers: [
      { text: "Kurzbezeichnung", value: "node.name" },
      { text: "Beschreibung", value: "node.description", sortable: false },
      { text: "Prüfbericht", value: "node.testReport", sortable: false },
      { text: "Aktionen", value: "node.id", sortable: false }
    ]
  }),
  methods: {
    async deleteProject() {
      await this.$apollo.mutate({
        mutation: PROJECT_DELETE,
        variables: { id: this.removeProject!.id }
      });
      this.removeProject = null;
      this.$apollo.queries.projects.refetch();
      this.projects!;
    }
  },
  mounted() {
    document.title = "Hydromapper - Projektverwaltung";
    this.$store.commit("setToolbarTitle", "Administration: Projektverwaltung");
  }
});
